import { HttpClient, HttpParams } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { PersonnePhysiqueDto } from '../../models/personne-physique-dto.model';
import { UserInfoService } from '../user-info/user-info.service';

@Injectable({
  providedIn: 'root'
})
export class PersonnePhysiqueService {

  private readonly store: Storage = sessionStorage;

  constructor(
    private readonly http: HttpClient,
    private readonly userInfo: UserInfoService
  ) {}

  /**
   * Get personne from IdNatPs
   * @param typePersonne criteres de recherche de personne physique
   * @param idPersonne criteres de recherche de personne physique
   */
  public getPersonneFromIdNatPs(typePersonne: string, idPersonne: string): Observable<any> {
    const params = new HttpParams()
      .set('typePersonne', typePersonne)
      .set('idPersonne', idPersonne);

    return this.http.get(`${environment.API_URL}habilitations/personnePhysique/getPersonne`, { params });
  }

  /**
   * Update mail number from IdNatPs
   * @param typePersonne criteres de recherche de personne physique
   * @param idPersonne criteres de recherche de personne physique
   * @param email email
   * @param numeroDeTel numeroDeTel
   */
  public updateMailNumberFromIdNatPs(personne: PersonnePhysiqueDto): Observable<any> {
    return this.http.post(
      `${environment.API_URL}habilitations/personnePhysique/updatePersonne`,
      personne,
      { observe: 'response' }
    );
  }

}
